import(/* webpackMode: "eager" */ "/codebuild/output/src2907544099/src/witmetrics-auth/src/app/layout.tsx")